import {kSystemIcons} from "../../../constants/icons";
import {kVoidTexts} from "../../../constants/texts";

export default function CoursesLevelAsVoid() {
    // Used in CoursesLevelAsList to display empty
    // LevelAs list

    // BUILD
    return (
        <div className={"w-full flex flex-col justify-center items-center text-greyLight7 px-[48px]"}>
            <i className={`material-icons text-[24px] lg:text-[32px]`}>
                {kSystemIcons.support}
            </i>
            <span className={"text-center font-normal text-[16px] mt-[8px]"}>
                {kVoidTexts.levelAsList}
            </span>
        </div>
    );
}